import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { FormControl, FormLabel } from '@material-ui/core'
import { TreeSelect } from 'antd'
import 'antd/dist/antd.css'

class TreeDataSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'TreeDataSelect', options)
        }
        this.state = {
            labelTitle: '',
            disabled: false,
            disabledList: [],
            treeData: [],
            checkedList: []
        }
    }

    componentDidMount() {
        this.setState({
            labelTitle: this.props.labelTitle
        })
    }

	componentDidUpdate() {
        const { treeData, checkedList } = this.props
        /** 比對treeData是否更新 */
        if (treeData.length) {
            const isMatch = []
            this.state.treeData.forEach(prevItem => {
                const _match = this.props.treeData.find(nextItem => {
                    return nextItem.value === prevItem.value
                })
                _match && isMatch.push(_match)
            })
            if ((this.props.treeData.length !== this.state.treeData.length) || (isMatch.length !== this.props.treeData.length)) {
                this.setState({
                    treeData: this.props.treeData
                })
            }
        }
        /** 比對勾選項目是否更新 */
        const isMatch = checkedList.filter(item => {
            return this.state.checkedList.includes(item)
        })
        if ((isMatch.length !== checkedList.length) || (checkedList.length !== this.state.checkedList.length)) {
            this.setState({
                checkedList: checkedList
            })
        }
	}

    render() {
        return (
            <>
                <FormControl
                    className={this.props.classes.formControl}
                    disabled={this.state.disabled}
                    >
                    <FormLabel className={this.props.classes.shrink}>{this.state.labelTitle}</FormLabel>
                    <TreeSelect
                        className={this.props.classes.treeSelect}
                        treeData={this.state.treeData}
                        value={this.state.checkedList}
                        onChange={(value) => {
							this.props.checkedValue(value)
                        }}
                        disabled={this.state.disabled}
                        maxTagCount={1}
                        treeCheckable={true}
                        showSearch={true}
                        listHeight={64}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        searchPlaceholder={this.t('pleaseSelect')}
                        dropdownStyle={{ zIndex: 3000 }}
                    />
                </FormControl>
            </>
        )
    }
}

TreeDataSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    options: PropTypes.object,
	disabled: PropTypes.bool,
	checkedValue: PropTypes.func,
	checkedList: PropTypes.array,
	disabledList: PropTypes.array,
    treeData: PropTypes.array,
    labelTitle: PropTypes.string,
}

const styles = (theme) => {
    return {
		treeSelect: {
            width: 240,
        },
        formControl: {
            margin: theme.spacing(1),
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
    }
}

export default hoc(styles)(TreeDataSelect)
